export default {
    getAllNotifications: () => {
        return {
            url: '/fhe/notifications',
            method: 'GET'
        };
    },
    getNotificationDetails: notificationId => {
        return {
            url: '/fhe/notifications/:notificationId',
            method: 'GET',
            route_params: {
                notificationId
            }
        };
    },
    getNotificationsButtons: () => {
        return {
            url: '/fhe/defaultNotificationsButtons',
            method: 'GET'
        };
    },
    updateNotificationDetails: (notificationId, form) => {
        return {
            url: '/fhe/notifications/:notificationId',
            method: 'PATCH',
            route_params: {
                notificationId
            },
            patch_params: form
        };
    },
    addNotification: form => {
        return {
            url: '/fhe/notifications',
            method: 'PATCH',
            patch_params: form
        };
    }
};



// WEBPACK FOOTER //
// ./environments/fhe/data/Notifications/api.js